import { Stack, useTheme } from "@mui/material";
import React from "react";
import OrderRow from "./OrderRow";
export default function Order({ orders }) {
  const theme = useTheme();

  const items = orders?.map((item, index) => {
    return <OrderRow key={index} item={item} />;
  });

  return (
    <Stack
      direction={"column"}
      py={"10px"}
      spacing={"10px"}
    >
      {items?.length > 0 ? (
        items
      ) : (
        <Stack
          sx={{
            color: theme.palette.primary.main,
            justifyContent: "center",
            fontSize: "1.2rem",
            alignItems: "center",
            height: "400px",
            width: "100%",
          }}
        >
          هنوز سفارشی ثبت نشده است
        </Stack>
      )}
    </Stack>
  );
}

